import React from 'react';
import ReactDOM from 'react-dom';
import { Web3ReactProvider } from '@web3-react/core'
import { BrowserProvider } from 'ethers'
import { AuthProvider } from './context/authContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function getLibrary(provider) {
  const library = new BrowserProvider(provider)
  library.pollingInterval = 12000
  return library
}

ReactDOM.render(
  <>
    <Web3ReactProvider getLibrary={getLibrary}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Web3ReactProvider>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
